import React, {Component} from 'react'
import classNames from 'classnames'
import ClickOutside from 'react-onclickoutside'

import Symbol from './../../../Symbol'
import {Wrapper, MenuItem} from './components/Styled'
import getMenuStructure from '../../menuStructure'

class HeaderMenuDesktop extends Component {
  constructor (props) {
    super(props)

    this.state = {
      showMenu: false
    }

    this.items = getMenuStructure()
  }

  handleShowHideMenu (menuTitle) {
    this.setState({showMenu: this.state.showMenu === menuTitle ? false : menuTitle})
  }

  handleClickOutside () {
    this.setState({showMenu: false})
  }

  renderItem (item, key) {
    return (
      <li key={key} className='menu-item-link'>
        {item.hasOwnProperty('icon') &&
        <div className='icon-container'>
          <span>{item.icon}</span>
        </div>
        }
        <div className='title-container'>
          <a href={item.url}>{item.title}</a>
        </div>
      </li>
    )
  }

  renderMenu (items) {
    return (
      <ul className='menu-item-list'>
        {
          items.map((menuGroup, key) => {
            let html = []
            if (menuGroup.hasOwnProperty('title')) {
              html.push(<li key={`item-${key}`} className='menu-item-group-title'>{menuGroup.title}</li>)
            }

            menuGroup.items.forEach((menuItem, itemKey) => {
              html.push(this.renderItem(menuItem, `item-${key}-${itemKey}`))
            })

            if (menuGroup.title === 'FOR PUPPY SEEKERS') {
              html.push(<hr key={`hr-item-${key}`} />)
            }

            return html
          })
        }
      </ul>
    )
  }

  render () {
    return (
      <Wrapper>
        <div className='site-menu__header'>
          <MenuItem className='normal'>
            <div className='menu-item-title-container'>
              <span className='menu-item-title'>
                <a href='/'>HOME</a>
              </span>
            </div>
          </MenuItem>
          {
            this.items.map(menu => (
              <MenuItem key={menu.title} className={menu.hasOwnProperty('type') ? menu.type : 'normal'}>
                <div className={classNames(
                  'menu-item-title-container',
                  {'selected-menu-item': this.state.showMenu === menu.title}
                )} onClick={() => this.handleShowHideMenu(menu.title)}>
                  <span className='menu-item-title'>
                    {menu.title}
                  </span>
                  <span className='menu-item-symbol'>
                    <Symbol className={classNames(
                      'icon-arrow-right',
                      {'icon-arrow-right--selected': this.state.showMenu === menu.title}
                    )} name='icon-arrow-right' />
                  </span>
                </div>
                <div className='menu-item-dropdown-container'>
                  <div className='menu-item-dropdown'
                    style={{display: this.state.showMenu === menu.title ? 'block' : 'none', top: '8px'}}>
                    {this.renderMenu(menu.menu)}
                  </div>
                </div>
              </MenuItem>
            ))
          }
        </div>
      </Wrapper>
    )
  }
}

export default ClickOutside(HeaderMenuDesktop)
